import React from 'react';

const TermsServices = () => {
  return (
    <div className="flex">
      <div className="w-64 h-280 p-5 bg-gray-100 p-20">
        <h2 className="font-semibold text-lg mb-5">Terms</h2>
        <ul className="text-sm">
          <li className="mb-2">
            <a href="/privacypolicy" className="block p-2 bg-[#F37920]">Privacy Policy</a>
          </li>
          <li className="mb-2">
            <a href="/terms" className="block p-2 hover:bg-[#F37920]">Terms and Condition</a>
          </li>
        </ul>
      </div>
      <div className="flex-1 p-5">
        <div className="mb-4">
        “Please read these terms and conditions carefully.<br/>
        <br/>

By accessing the site, and any pages thereof, you agree to be bound by the terms and conditions below. The information<br/> and material contained in these pages and the terms, conditions and descriptions that appear are subject to change.”<br/>
<br/>

<h3>No Warranty</h3>
The information and material contained in this site including text, graphics, links or other items are provided “as <br/>is”, “as available”. TRJ & Associates does not warrant the accuracy, adequacy or completeness of this information and<br/> material and expressly disclaims liability for errors or omissions in this information and materials. No warranty of any kind, implied,<br/> express or statutory, including but not limited to the warranties of non-infringement of third-party rights, title,<br/> merchantability, fitness for a particular purpose and freedom from computer virus, is given in conjunction with the<br/> information and material.<br/>
<br/>

<h3>Copyright</h3>
Material copyrighted by or owned by TRJ & Associates, any individual or entity are presented here for personal, non-commercial<br/> use only. Documents, content or images contained in this web site may not be copied or reproduced in any form without<br/> the written permission of TRJ & Associates.<br/>
<br/>

<h3>Limitation Of Liability</h3>
In no event will TRJ & Associates be liable for any damages, including without limitation direct or indirect, special, incidental or<br/> consequential damages, losses or expenses arising in connection with any failure of performance, error, omission,<br/> interruption, defect, delay in operation or transmission, computer virus or line or system failure, even TRJ & Associates, or<br/> representation thereof, are advised of the possibility of such damages, losses or expenses. Hyperlinks to other internet<br/> resources are at your own risk; the content, accuracy<br/>
<br/>
        </div>
      </div>
    </div>
  );
}

export default TermsServices;